var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "clearfix" }, [
    _c(
      "div",
      {
        ref: "noPermModal",
        staticClass: "reveal",
        attrs: { id: "noPermModal", "data-reveal": "" },
      },
      [
        _c("div", { staticClass: "tender-confirm clearfix" }, [
          _c("p", { staticClass: "confirm-header" }, [
            _vm._v(_vm._s(_vm.$t("warn.perms.title"))),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "msg_hint" }, [
            _vm._v(_vm._s(_vm.$t("warn.perms.hint"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row align-center" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { id: "confirm_ok", type: "button", "data-close": "" },
              },
              [_vm._v(_vm._s(_vm.$t("action.ok")))]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }